var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvances(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.983,
    height: 19.395,
    viewBox: "0 0 19.983 19.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20629",
    "data-name": "Group 20629",
    transform: "translate(-8972.16 3836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20645",
    "data-name": "Path 20645",
    d: "M15.207,37.1,9.634,39.727l-1.289-.953.173-.007a1.507,1.507,0,0,0,.5-2.91L6.89,35.023a.525.525,0,0,0-.371,0L3.5,36.149a.52.52,0,0,0-.339.488v5.154a.519.519,0,0,0,.405.506L9.6,43.637a.474.474,0,0,0,.118.014.5.5,0,0,0,.263-.073l6.592-3.886a1.464,1.464,0,0,0,.468-2.085A1.459,1.459,0,0,0,15.207,37.1Zm1.039,1.42a.429.429,0,0,1-.2.274L9.634,42.581,4.2,41.375V37L6.7,36.066l1.94.762a.468.468,0,0,1-.152.9l-1.656.062a.521.521,0,0,0-.291.939l2.729,2.019a.513.513,0,0,0,.53.052L15.65,38.05a.424.424,0,0,1,.533.145A.419.419,0,0,1,16.246,38.525Z",
    transform: "translate(8969 -3860.256)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20646",
    "data-name": "Path 20646",
    d: "M33.757,5.354,27.719,4.017a.533.533,0,0,0-.378.059L20.75,7.963a1.464,1.464,0,0,0-.468,2.085,1.438,1.438,0,0,0,.752.565,3.607,3.607,0,1,0,4.309-1.579L27.7,7.925l1.289.953-.173.007a1.507,1.507,0,0,0-.5,2.91l2.123.835a.539.539,0,0,0,.371,0L33.83,11.5a.52.52,0,0,0,.339-.488V5.864A.536.536,0,0,0,33.757,5.354Zm-7.045,7.08a2.57,2.57,0,1,1-2.57-2.57A2.574,2.574,0,0,1,26.711,12.434Zm6.411-1.777-2.494.932-1.94-.762a.468.468,0,0,1,.152-.9L30.5,9.861a.521.521,0,0,0,.291-.939L28.059,6.9a.528.528,0,0,0-.308-.1.543.543,0,0,0-.222.048L21.675,9.6a.424.424,0,0,1-.533-.145.416.416,0,0,1-.062-.333.429.429,0,0,1,.2-.274l6.415-3.779,5.431,1.205Z",
    transform: "translate(8957.974 -3840.005)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvances);
export default __webpack_public_path__ + "static/media/Advances.0d4b41324c464332eebff3ac50ceebe6.svg";
export { ForwardRef as ReactComponent };